import React, { useState, useEffect } from 'react'
import { Avatar, Grid, Link, makeStyles } from '@material-ui/core'
import motoristaFotoPadraoRepository from './motoristaFotoPadraoRepository'
import termoEPoliticaRepository from '../Solicitacoes/Requisicoes/TermoEPolitica/TermoEPoliticaRepository'

const useStyles = makeStyles(theme => ({
  avatar: {
    width: theme.spacing(20),
    height: theme.spacing(20)
  },
  grande: {
    width: theme.spacing(40),
    height: theme.spacing(40)
  }
}))

function MotoristaFotoPadraoAvatar({ cpf, fetchingFotoPadrao, grande }) {
  const classes = useStyles()
  const [data, setData] = useState()

  useEffect(() => {
    const fetchData = async cpf => {
      const termoResponse = await termoEPoliticaRepository.verificar({ cpf })

      if (termoResponse.ok && termoResponse.data?.data?.pessoa?.fotoUrl) {
        setData({ imagem: termoResponse.data.data.pessoa.fotoUrl })
        return
      }

      const response = await motoristaFotoPadraoRepository.fetchFotoPadrao(cpf)
      if (response.ok) {
        setData(response.data)
      }
    }
    fetchData(cpf)
  }, [cpf, fetchingFotoPadrao])

  return data ? (
    <Grid container justifyContent="center" alignItems="center">
      <Link href={data.imagem} target="_blank">
        <Avatar
          src={data.imagem}
          variant="square"
          className={grande ? classes.grande : classes.avatar}
        />
      </Link>
    </Grid>
  ) : null
}

export default MotoristaFotoPadraoAvatar
